// import React, { useEffect, useRef } from "react";
// import { Icon } from "@iconify/react";
// import { gsap } from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";

// gsap.registerPlugin(ScrollTrigger);

// export default function AboutSection() {
//     const sectionRef = useRef(null);
//     const textRef = useRef(null);
//     const statsRef = useRef([]);
//     const circleTextRef = useRef(null);
//     const textCircleRef = useRef(null);

//     useEffect(() => {
//         gsap.to(textCircleRef.current, {
//             rotation: 360,
//             duration: 15,
//             repeat: -1,
//             ease: "linear",
//             transformOrigin: "center center",
//         });
//     }, []);

//     useEffect(() => {
//         const ctx = gsap.context(() => {
//             gsap.from(textRef.current, {
//                 opacity: 0,
//                 y: 50,
//                 duration: 1,
//                 ease: "power3.out",
//                 scrollTrigger: {
//                     trigger: textRef.current,
//                     start: "top 85%",
//                 },
//             });

//             statsRef.current.forEach((el, i) => {
//                 gsap.from(el, {
//                     opacity: 0,
//                     y: 40,
//                     delay: i * 0.2,
//                     duration: 0.8,
//                     ease: "power2.out",
//                     scrollTrigger: {
//                         trigger: el,
//                         start: "top 90%",
//                     },
//                 });
//             });
//         }, sectionRef);

//         gsap.to(circleTextRef.current, {
//             rotation: 360,
//             duration: 15,
//             repeat: -1,
//             ease: "linear",
//             transformOrigin: "center center",
//         });

//         return () => ctx.revert();
//     }, []);

//     return (
//         <section
//             ref={sectionRef}
//             className="relative bg-fixed bg-center bg-cover text-white py-20 px-6 md:px-16 overflow-hidden"
//             style={{
//                 backgroundImage:
//                     "url('https://images.unsplash.com/photo-1672895349784-c252d8273a9f?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=1170')",
//             }}
//         >
//             {/* Overlay for contrast */}
//             <div className="absolute inset-0 bg-black/80 backdrop-blur-[2px]"></div>

//             <div className="relative max-w-screen-2xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
//                 <div ref={textRef}>
//                     <div className="flex items-center gap-2 mb-4">
//                         <button className="bg-white/10 border border-white/20 px-5 py-2 rounded-full text-sm mb-6 hover:bg-white/20 transition-all flex">
//                             <Icon
//                                 icon="material-symbols:lightbulb-2-rounded"
//                                 className="mr-1.5 text-[#F26A33] drop-shadow-[0_0_8px_#F26A33]"
//                                 width="22"
//                                 height="20"
//                             />
//                             ABOUT OUR COMPANY
//                         </button>
//                     </div>

//                     <h2 className="text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-light text-gray-400 mb-4 leading-tight">
//                         Providing Tailored IT Solution{" "}
//                         <span className="text-white font-light">
//                             Ensuring Seamless Business
//                         </span>
//                     </h2>
//                     <h2 className="text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-light text-white leading-tight mb-6">
//                         Growth, Success.
//                     </h2>

//                     <div className="rounded-2xl overflow-hidden flex-1">
//                         <img
//                             src="https://themejunction.net/html/tekmino/demo/assets/images/about/h3-about-img.jpg"
//                             alt="IT Solutions"
//                             className="w-full h-[380px] object-cover rounded-2xl"
//                         />
//                     </div>
//                 </div>

//                 <div className="relative flex flex-col gap-8">
//                     <p className="text-gray-300 max-w-xl mb-2 text-lg lg:pl-16">
//                         We are dedicated to transforming businesses through innovative and
//                         future-ready IT solutions. With a passion for technology and a
//                         commitment to excellence, we empower organizations — from cloud
//                         computing to AI-driven solutions.
//                     </p>

//                     <div className="lg:flex gap-12 items-center lg:pl-16">
//                         <ul className="space-y-2 mb-8 text-gray-200">
//                             {[
//                                 "Tailored IT Solutions.",
//                                 "Future-Ready Infrastructure.",
//                                 "Industry Expertise.",
//                             ].map((text, i) => (
//                                 <li
//                                     key={i}
//                                     className="flex items-center gap-2 text-base lg:text-lg"
//                                 >
//                                     <Icon
//                                         icon="mdi:check-circle"
//                                         className="text-orange-400 text-lg lg:text-3xl drop-shadow-[0_0_8px_#F26A33]"
//                                     />
//                                     {text}
//                                 </li>
//                             ))}
//                         </ul>

//                         {/* Rotating circular logo */}
//                         <div className="flex items-center gap-8">
//                             <div className="relative">
//                                 <div
//                                     className="relative grid place-items-center rounded-full border-4 border-gray-800 shadow-2xl"
//                                     style={{
//                                         background:
//                                             "radial-gradient(circle at 30% 30%, rgba(216,255,95,0.12), rgba(0,0,0,0.4))",
//                                         width: "11rem",
//                                         height: "11rem",
//                                     }}
//                                 >
//                                     <div
//                                         className="bg-white/48 rounded-full p-4 shadow-lg grid place-items-center"
//                                         style={{
//                                             backgroundImage:
//                                                 "url('https://api.visko.group/public/assets/img/uploads/gallery/photo-1730817966782-d90134a1b4a2.webp')",
//                                             width: "8rem",
//                                             height: "8rem",
//                                         }}
//                                     >
//                                         <svg
//                                             ref={textCircleRef}
//                                             viewBox="0 0 100 100"
//                                             className="absolute w-40 h-40"
//                                         >
//                                             <defs>
//                                                 <path
//                                                     id="circlePath"
//                                                     d="M 50, 50 m -35, 0 a 35,35 0 1,1 70,0 a 35,35 0 1,1 -70,0"
//                                                 />
//                                             </defs>
//                                             <text fill="#fff" fontSize="9" letterSpacing="1.5">
//                                                 <textPath href="#circlePath">
//                                                     ● FEATURED ROLE ● APPLY NOW ● FEATURED ROLE ●
//                                                 </textPath>
//                                             </text>
//                                         </svg>
//                                         <div className="absolute inset-0 flex items-center justify-center">
//                                             <img
//                                                 src={require("../assets/viskologo.webp")}
//                                                 alt="Visko Logo"
//                                                 className="w-10"
//                                             />
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     {/* Stats */}
//                     <div className="flex flex-wrap gap-6">
//                         {[
//                             {
//                                 num: "10m",
//                                 title: "Users",
//                                 desc: "Transforming Ideas into Digital Excellence.",
//                             },
//                             {
//                                 num: "03x",
//                                 title: "Faster",
//                                 desc: "Transforming Ideas into Digital Excellence.",
//                             },
//                         ].map((item, i) => (
//                             <div
//                                 key={i}
//                                 ref={(el) => (statsRef.current[i] = el)}
//                                 className="bg-[#111]/80 rounded-xl px-8 py-6 flex-1 min-w-[200px]"
//                             >
//                                 <h3 className="text-4xl font-bold">{item.num}</h3>
//                                 <p className="text-sm lg:text-2xl font-bold text-white mt-10">
//                                     {item.title} <br />
//                                     <span className="text-gray-400 text-lg font-normal">
//                                         {item.desc}
//                                     </span>
//                                 </p>
//                             </div>
//                         ))}
//                     </div>

//                     {/* Mission / Vision Cards */}
//                     <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
//                         {[
//                             {
//                                 icon: "mdi:rocket-launch",
//                                 title: "Our Mission",
//                                 text: "Empowering businesses with technology-driven innovation.",
//                             },
//                             {
//                                 icon: "mdi:lightbulb-on-outline",
//                                 title: "Our Vision",
//                                 text: "To redefine digital experiences with creative excellence.",
//                             },
//                         ].map((card, i) => (
//                             <div
//                                 key={i}
//                                 className="bg-gradient-to-br from-white/5 to-white/10 border border-white/10 rounded-2xl p-6 hover:scale-[1.03] transition-transform duration-300"
//                             >
//                                 <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-[#F26A33]/20 text-[#F26A33] mb-4">
//                                     <Icon icon={card.icon} width="28" />
//                                 </div>
//                                 <h4 className="text-xl font-semibold mb-2">{card.title}</h4>
//                                 <p className="text-gray-300 text-lg">{card.text}</p>
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//             </div>
//         </section>

//     );
// }


import React, { useEffect, useRef } from "react";
import { Icon } from "@iconify/react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function AboutSection() {
    const sectionRef = useRef(null);
    const textRef = useRef(null);
    const statsRef = useRef([]);
    const textCircleRef = useRef(null);

    useEffect(() => {
        gsap.to(textCircleRef.current, {
            rotation: 360,
            duration: 15,
            repeat: -1,
            ease: "linear",
            transformOrigin: "center center",
        });
    }, []);

    useEffect(() => {
        const ctx = gsap.context(() => {
            gsap.from(textRef.current, {
                opacity: 0,
                y: 50,
                duration: 1,
                ease: "power3.out",
                scrollTrigger: {
                    trigger: textRef.current,
                    start: "top 85%",
                },
            });

            statsRef.current.forEach((el, i) => {
                gsap.from(el, {
                    opacity: 0,
                    y: 40,
                    delay: i * 0.2,
                    duration: 0.8,
                    ease: "power2.out",
                    scrollTrigger: {
                        trigger: el,
                        start: "top 90%",
                    },
                });
            });
        }, sectionRef);

        return () => ctx.revert();
    }, []);

    return (
        <section
            ref={sectionRef}
            className="relative bg-fixed bg-center bg-cover text-white py-16 sm:py-20 px-4 sm:px-8 lg:px-16 overflow-hidden"
            style={{
                backgroundImage:
                    "url('https://api.visko.group/public/assets/img/uploads/gallery/photo-1672895349784-c252d8273a9f.webp')",
            }}
        >
            {/* Dark overlay */}
            <div className="absolute inset-0 bg-black/80 backdrop-blur-[2px]"></div>

            <div className="relative max-w-screen-2xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 xl:gap-16 items-center">
                {/* LEFT TEXT + IMAGE */}
                <div ref={textRef}>
                    <div className="flex items-center gap-2 mb-6">
                        <button className="bg-white/10 border border-white/20 px-4 sm:px-6 py-2 rounded-full text-xs sm:text-sm hover:bg-white/20 transition-all flex items-center">
                            <Icon
                                icon="material-symbols:lightbulb-2-rounded"
                                className="mr-2 text-[#F26A33] drop-shadow-[0_0_8px_#F26A33]"
                                width="22"
                                height="22"
                            />
                            {/* ABOUT OUR COMPANY */}
                            WHY CHOOSE US
                        </button>
                    </div>

                    <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-light text-gray-400 mb-0 leading-tight">
                        Providing Tailored IT Solutions{" "}
                        <span className="text-white">Ensuring Seamless Business</span>
                    </h2>
                    <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-light text-white leading-tight mb-6">
                        Growth Across Dubai & UAE
                    </h2>

                    <div className="rounded-2xl overflow-hidden">
                        <img
                            src="https://api.visko.group/public/assets/img/uploads/gallery/h3-about-img.webp"
                            alt="IT Solutions"
                            className="w-full h-[240px] sm:h-[300px] md:h-[380px] object-cover rounded-2xl"
                        />
                    </div>
                </div>

                {/* RIGHT CONTENT */}
                <div className="relative flex flex-col gap-8">
                    <p className="text-gray-300 text-base sm:text-lg max-w-xl lg:pl-10 xl:pl-16">
                        With 10+ years of hands-on experience serving startups, SMEs, and enterprises in Dubai, we deliver reliable, secure, and future-ready IT solutions. From cloud infrastructure to cybersecurity and digital transformation, we help your business stay ahead in the competitive UAE market.
                    </p>

                    <div className="lg:flex gap-10 items-center lg:pl-10 xl:pl-16">
                        {/* Feature List */}
                        <ul className="space-y-3 mb-8 text-gray-200">
                            {[
                                "Customized IT Solutions for Dubai Businesses",
                                "Cloud & Future-Ready Infrastructure",
                                "Certified IT Experts & 24/7 Support",
                            ].map((text, i) => (
                                <li
                                    key={i}
                                    className="flex items-center gap-2 text-base sm:text-lg"
                                >
                                    <Icon
                                        icon="mdi:check-circle"
                                        className="text-orange-400 text-lg sm:text-2xl drop-shadow-[0_0_8px_#F26A33]"
                                    />
                                    {text}
                                </li>
                            ))}
                        </ul>

                        {/* Rotating Circular Logo */}
                        <div className="flex justify-center sm:justify-start">
                            <div className="relative">
                                <div
                                    className="relative grid place-items-center rounded-full border-4 border-gray-800 shadow-2xl"
                                    style={{
                                        background:
                                            "radial-gradient(circle at 30% 30%, rgba(216,255,95,0.12), rgba(0,0,0,0.4))",
                                        width: "9rem",
                                        height: "9rem",
                                    }}
                                >
                                    <div
                                        className="bg-white/30 rounded-full p-3 shadow-lg grid place-items-center relative"
                                        style={{
                                            backgroundImage:
                                                "url('https://api.visko.group/public/assets/img/uploads/gallery/photo-1730817966782-d90134a1b4a2.webp')",
                                            width: "7rem",
                                            height: "7rem",
                                            backgroundSize: "cover",
                                            backgroundPosition: "center",
                                        }}
                                    >
                                        <svg
                                            ref={textCircleRef}
                                            viewBox="0 0 100 100"
                                            className="absolute w-32 h-32"
                                        >
                                            <defs>
                                                <path
                                                    id="circlePath"
                                                    d="M 50, 50 m -35, 0 a 35,35 0 1,1 70,0 a 35,35 0 1,1 -70,0"
                                                />
                                            </defs>
                                            <text fill="#fff" fontSize="8" letterSpacing="1.5">
                                                <textPath href="#circlePath">
                                                    ● DESIGN ● DEVELOPMENT ● DEPLOYMENT ●
                                                </textPath>
                                            </text>
                                        </svg>
                                        <div className="absolute inset-0 flex items-center justify-center">
                                            <img
                                                // src={require("../assets/viskologo.webp")}
                                                src="https://api.visko.group/public/assets/img/uploads/gallery/viskologo.webp"
                                                alt="Visko Logo"
                                                className="w-8 sm:w-10"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Stats */}
                    <div className="flex flex-wrap gap-6">
                        {[
                            {
                                num: "1",
                                title: "Reliable IT Solutions",
                                desc: "We design, implement, and manage secure IT systems that keep your Dubai business running without downtime.",
                            },
                            {
                                num: "03x",
                                title: "3x Faster Digital Growth",
                                desc: "Accelerate operations with cloud migration, automation, and modern software solutions.",
                            },
                            
                        ].map((item, i) => (
                            <div
                                key={i}
                                ref={(el) => (statsRef.current[i] = el)}
                                className="bg-[#111]/80 rounded-xl px-6 sm:px-8 py-5 sm:py-6 flex-1 min-w-[160px] sm:min-w-[200px]"
                            >
                                <h3 className="text-3xl sm:text-4xl font-bold">{item.num}</h3>
                                <p className="text-base sm:text-lg font-semibold text-white mt-6">
                                    {item.title}
                                </p>
                                <p className="text-gray-400 text-sm sm:text-base mt-2">
                                    {item.desc}
                                </p>
                            </div>
                        ))}
                    </div>

                    {/* Mission / Vision Cards */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                        {[
                            {
                                icon: "mdi:rocket-launch",
                                title: "Our Mission",
                                text: "To empower Dubai businesses with smart technology, secure infrastructure, and innovative digital solutions that drive measurable growth.",
                            },
                            {
                                icon: "mdi:lightbulb-on-outline",
                                title: "Our Vision",
                                text: "To become one of the most trusted IT service providers in Dubai and the UAE, delivering excellence through innovation and customer success.",
                            },
                        ].map((card, i) => (
                            <div
                                key={i}
                                className="bg-gradient-to-br from-white/5 to-white/10 border border-white/10 rounded-2xl p-5 sm:p-6 hover:scale-[1.03] transition-transform duration-300"
                            >
                                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center rounded-xl bg-[#F26A33]/20 text-[#F26A33] mb-3 sm:mb-4">
                                    <Icon icon={card.icon} width="26" className="sm:w-7 sm:h-7" />
                                </div>
                                <h4 className="text-lg sm:text-xl font-semibold mb-1 sm:mb-2">
                                    {card.title}
                                </h4>
                                <p className="text-gray-300 text-sm sm:text-base">
                                    {card.text}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
